import { Injectable } from '@angular/core';
import { MasterDataRepository } from '../../../core/data/repositories/masterdata.repository';
 import { timeout } from 'rxjs';
import { CEFilterDTO } from '../model/construction-element-test-filter';
import { ConstructionElementDataRepository } from '../../../core/data/repositories/constructionelementdata.repository';

@Injectable({
    providedIn: 'root'
  })
export class ConstructionElementService {

  constructor(
    private masterDataRepository: MasterDataRepository,
    private constructionelementdatarepository: ConstructionElementDataRepository
  ) { }

  getSearchCE(data: CEFilterDTO) {
    return this.constructionelementdatarepository.searchCE(data);
  }

  getExportSearchCE(data: CEFilterDTO) {
    return this.constructionelementdatarepository.exportCE(data);
  }

  getExportSearchCert(data: CEFilterDTO) {
    return this.constructionelementdatarepository.exportCert(data);
  }

  
  getExportSearchTestCert(data: CEFilterDTO) {
    return this.constructionelementdatarepository.exportTestCert(data);
  }

  getSearchCECert(data: CEFilterDTO) {
    return this.constructionelementdatarepository.getSearchCECert(data);
  }

  getSearchCETestCert(data: CEFilterDTO) {
    return this.constructionelementdatarepository.getSearchCETestCert(data);
  }

}